import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import {
	EditorComponent,
	Input,
	Textarea,
} from "../../components/shared/FormComponentsNew";
import Loader from "../../components/shared/Loader";
import { getId } from "../../helpers";
import { getData, postData } from "./getData";
import AddButton from "../../components/shared/AddButton";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import ImageUpload from "./ImageUpload";
import StatisticsArray from "./featuresArray";

const AddCategory = () => {
	console.log("add category add oage");
	const dispatch = useDispatch();

	const navigate = useHistory();
	const categoryType = window.location.pathname
		?.split("/")
		?.at(-1)
		?.replace("-add", "");

	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(false);
	const [subCategories, setSubCategories] = useState([]);
	const [defaultSubCategoryVal, setDefaultSubCategoryVal] = useState({
		value: "",
		label: "",
	});
	const [picture, setPicture] = useState();

	const mainCategories = categories?.filter(category => !category?.category);

	const {
		register,
		handleSubmit,
		control,
		setValue,
		getValues,
		watch,
		reset,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "اضافة تصنيف جديد",
				breadcrumb: `اضافة تصنيف ${categoryType === "sub" ? "فرعي" : "اساسي"}`,
				button: {
					show: false,
				},
			})
		);
		init();
	}, []);

	useEffect(() => {
		setValue("image", picture?.path || picture);
	}, [picture, setValue]);

	const init = async () => {
		await getData({
			setData: data => setCategories(data?.data?.page?.sections),
			setLoading,
			url: `/pages/categories`,
		});
	};

	const handleSelectOptions = options => {
		if (options.length < 0) return [];

		return options.map(option => {
			return {
				value: option?.slug,
				label: option?.name?.ar,
			};
		});
	};

	const onSubmit = data => {
		data.name = data.title;
		data.title = data.title?.en || data.title;

		postData({
			url: `pages/categories/sections`,
			body: { section: data },
			setLoading,
			setData: data => {
				// setCategories(data)
				navigate.push(`/categories/${categoryType}`);
			},
		});
	};

	if (loading) return <Loader />;

	return (
		<>
			<div className="acc-form">
				<div className="card">
					<div className="card-body">
						<form onSubmit={handleSubmit(onSubmit)}>
							<Col md={12}>
								<ImageUpload
									selectedImage={picture}
									setSelectedImage={setPicture}
								/>
								{/* title  */}
								<Row>
									<Col lg={6} xs={12}>
										<Input
											langId="الاسم"
											name="name.ar"
											register={register}
											errors={errors}
										/>
									</Col>
									<Col lg={6} xs={12}>
										<Input
											langId="الاسم"
											name="name.en"
											register={register}
											errors={errors}
										/>
									</Col>
								</Row>

								{/* description  */}
								<Row>
									<Col lg={6} xs={12}>
										{/* <Textarea
											langId="الوصف"
											name="description.ar"
											register={register}
											errors={errors}
										/> */}
										<EditorComponent
											langId="الوصف"
											name={`description.ar`}
											control={control}
											errors={errors}
										/>
									</Col>
									<Col lg={6} xs={12}>
										{/* <Textarea
											langId="الوصف"
											name="description.en"
											register={register}
											errors={errors}
										/> */}
										<EditorComponent
											langId="الوصف"
											name={`description.en`}
											control={control}
											errors={errors}
										/>
									</Col>
								</Row>
								{/* parert category */}
								{categoryType?.includes("sub") && (
									<Row>
										<Col lg={12} xs={12}>
											<div className="form-group ">
												<h5>
													{" "}
													التصنيف الرئيسي
													{/* <FormattedMessage id={"mainCategory"} /> */}
												</h5>
												<div>
													<Controller
														control={control}
														render={({
															field: { onChange, value, name, ref },
														}) => (
															<Select
																inputRef={ref}
																name={name}
																placeholder="التصنيف الرئيسي"
																// {
																// <FormattedMessage id={"mainCategory"} />
																// }
																options={handleSelectOptions(mainCategories)}
																onChange={selectedOption => {
																	// -------------------------------------------------------

																	setDefaultSubCategoryVal({
																		value: "",
																		label: "",
																	});
																	setSubCategories([]);

																	const subCategories = categories?.filter(
																		category =>
																			category?.category?._id ===
																			selectedOption?.value
																	);

																	setSubCategories(subCategories);
																	// --------------------------------
																	if (categoryType !== "sub-child")
																		onChange(selectedOption.value);
																}}
																isRtl={true}
																isSearchable={false}
																className="basic-single"
																classNamePrefix="select"
															/>
														)}
														name={"category"}
														rules={{
															required: categoryType === "sub" ? true : false,
														}}
													/>
												</div>
												<p className="error-hint">
													{
														errors?.category && "هذا الحقل مطلوب"
														// <FormattedMessage id={"requiredField"} />
													}
												</p>
											</div>
										</Col>
									</Row>
								)}

								<StatisticsArray
									{...{ control, register, errors, setValue, watch }}
								/>
								<AddButton />
							</Col>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default AddCategory;
